import React, {useEffect} from "react";
import {IMAGE_MIME_TYPE, LOADING_STATUS} from "utils/constants";
import _ from "lodash";
import ImageUnavailable from "./Image.unavailable";
import ImageLoading from "./Image.loading";
import FetchAttachmentBlobFunction from "components/taskdetails-remake/panels/attachments/FetchAttachmentBlob.function";
import {cacheAttachmentsImagesUrls} from "components/taskdetails-remake/taskDetails.action";
import {useDispatch, useSelector} from "react-redux";
import {Store} from "redux";
import * as reduxSelectors from "components/store/application.reducers";


const MAX_RELOAD_ATTEMPTS: number = 3;

export const getAttachmentId = (attachmentIds: string[] | undefined, index: number): string | undefined => {
    if (!Array.isArray(attachmentIds) || attachmentIds.length === 0) {
        return undefined;
    }
    return attachmentIds[Math.min(index, attachmentIds.length - 1)];
};

export const ImageDefault = ({id, key, zoom, style, src, rotation, collectionId,uid, docVersion,attachmentIds}: any): React.ReactElement => {
    //const imgMaxWidth = zoom;//(zoom * IMG_BASE.width) / 100;
    //const imgHeight = (zoom * IMG_BASE.height) / 100;

    const userData = useSelector((store: Store) => reduxSelectors.getUsersData(store));
    const [loadingStatus, setLoadingStatus] = React.useState<number | null>(null);
    const imageRef = React.useRef<HTMLImageElement>(null);
    const storedImages = useSelector((store: Store) => reduxSelectors.getImagesForRender(store));

    let reloadAttempts: number = 0;
    const dispatch = useDispatch();

    function reloadImage() {
        reloadAttempts += 1;
        imageRef.current?.setAttribute("src", src);
    }

    const debounceImageLoading = _.debounce(reloadImage, 1000);

    useEffect( () => {
        if (storedImages[collectionId] && storedImages[collectionId][id]?.dsURL==="") {
            const timeoutId = setTimeout(() => {
                const attachmentIndex = Math.max(id - 1, 0);
                const attachmentId = getAttachmentId(attachmentIds, attachmentIndex);
                FetchAttachmentBlobFunction(src, IMAGE_MIME_TYPE, userData, uid, docVersion, attachmentId)
                    .then((result) => {
                        dispatch(cacheAttachmentsImagesUrls(collectionId, id + 1, result));
                    })
                    .catch((error) => {
                        console.error('Error fetching attachment:', error);
                        setLoadingStatus(LOADING_STATUS.ERROR);
                    });
            }, 300);

            return () => clearTimeout(timeoutId);
        }
    }, [src]);

    const handleLoadError = () => {
        if (reloadAttempts >= MAX_RELOAD_ATTEMPTS) {
            setLoadingStatus(LOADING_STATUS.ERROR);
            return;
        }
        setLoadingStatus(LOADING_STATUS.LOADING);
        debounceImageLoading();
    }

    const renderImage = () => {
        if (loadingStatus === LOADING_STATUS.ERROR)
            return <ImageUnavailable/>;

        if (storedImages[collectionId][id]?.dsURL ==="" || loadingStatus === LOADING_STATUS.LOADING) {
            return <ImageLoading/>;
        }

        const doneLoading = loadingStatus !== LOADING_STATUS.ERROR && loadingStatus !== LOADING_STATUS.LOADING;

        if (storedImages[collectionId][id]?.dsURL !== "") {
            return <img
                ref={imageRef}
                className={`${doneLoading ? "attachment-image" : "hidden"}  ${rotation ? "rotate_" + rotation : ""}`}
                style={{width: zoom + "%"}}
                alt={`attachment_${id}`}
                onError={handleLoadError}
                src={storedImages[collectionId][id] ? storedImages[collectionId][id].dsURL : ""}
                role="presentation"/>
        }
    }

    return (
        <div className={`images-auto-sizer__page-container page_${id}`} style={style} key={key}>
            <div className={"attachment-image-container"}>
                {storedImages[collectionId] && renderImage()}
            </div>
        </div>
    )
}
export default ImageDefault;